export default "__VITE_ASSET__af3afbf9__"